import React, {useEffect} from "react";
import {Skeleton, Dialog, DialogTitle, DialogContent, IconButton, Typography,  ListItem, ListItemText} from "@mui/material";
import CloseIcon from "../../../assets/icons/close.png";
import moment from "moment";
import useAuthentication from "../../../hooks/useAuthentication";

const ProductAuthenticationViewDialog = (props) => {

    const {openProductView, setOpenProductView, productId} = props;

    const {isViewProduct, productViewDetails, getProductAuthenticationViewDetails} = useAuthentication();

    const handleCloseDialog = () => {
        setOpenProductView(false);
    }

    useEffect(() => {
        if (productId) {
            getProductAuthenticationViewDetails(productId);
        }
    }, [productId])


    return (
        <Dialog open={openProductView} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{style: {borderRadius: "8px", padding: " 20px 24px"}, elevation: 24}}>
            <DialogTitle sx={{display: "flex"}}>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{position: 'absolute', right: 36, top: 24}}
                >
                    <img alt="close-icon" src={CloseIcon} style={{height: 22}} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "20px 8px"}}>
                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Product ID:
                            </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, fontWeight: 500, ml: 1}}>
                                {productViewDetails?.product_id}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                               Product Name:
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {productViewDetails?.product_name}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Product Type:
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {(productViewDetails?.type === "RL") ? 
                                    "Retail Level" 
                                : 
                                    (productViewDetails?.type === "BL") ? 
                                        "Box Level" 
                                :   
                                    (productViewDetails?.type === "MPL") ?
                                        "Pallet Level" 
                                : 
                                    "N / A"
                                }
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Manufacturer:  
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {productViewDetails?.manufacturer}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                OVCode Reference:  
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {productViewDetails?.ovcode_reference}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Document Reference:  
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {productViewDetails?.document_reference}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Product Image:  
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {(productViewDetails?.image_url) ? productViewDetails?.image_url : "N / A"}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Authentication Status: 
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{fontSize: 16, ml: 1, color: 
                                (productViewDetails?.authentication_status == "Completed") ? 
                                    "#40BF7E" 
                                : 
                                    (productViewDetails?.authentication_status == "Pending") ?
                                        "#FFA500" 
                                :
                                    "#E76C59" 
                            }}>
                                {productViewDetails?.authentication_status}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Failure Reason:  
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {(productViewDetails?.failure_reason) ? productViewDetails?.failure_reason : "N / A"}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Product Info:  
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {(productViewDetails?.productInfo) ? productViewDetails?.productInfo : "N / A"}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Date Created:   
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(productViewDetails?.created_time).format('YYYY-MM-DD hh:mm:ss A')}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Date Updated:    
                             </Typography>
                        } 
                        secondary={(isViewProduct) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(productViewDetails?.updated_time).format('YYYY-MM-DD hh:mm:ss A')}
                            </Typography>
                        }
                    />
                </ListItem>
            </DialogContent>
        </Dialog>
    )
}

export default ProductAuthenticationViewDialog

